import { ArrowRight } from "lucide-react";

/**
 * Closing call-to-action: a solid accent panel with an inverted white
 * button, echoing the dashboard's premium banner.
 */
export default function LandingCTA({ onOpenAuth }) {
  return (
    <section className="py-16 sm:py-20">
      <div className="mx-auto max-w-[800px] px-6">
        <div className="rounded-[20px] bg-vaulzo-accent px-6 py-14 text-center sm:px-12">
          <h2 className="text-[26px] font-bold tracking-[-0.02em] text-white sm:text-[30px]">
            Start with a clearer picture today
          </h2>
          <p className="mx-auto mt-3 max-w-md text-[15px] leading-relaxed text-white/75">
            Open Vaulzo, add a few line items, and see net worth and allocation
            come into focus.
          </p>
          <div className="mt-8 flex justify-center">
            <button
              type="button"
              onClick={() => onOpenAuth()}
              className="inline-flex h-12 min-w-[220px] items-center justify-center gap-2 rounded-lg bg-white px-7 text-[15px] font-semibold text-vaulzo-accent transition-opacity hover:opacity-90"
            >
              Open Vaulzo
              <ArrowRight className="h-4 w-4" strokeWidth={2} />
            </button>
          </div>
          <p className="mt-4 text-[12px] text-white/50">
            Sign in or create an account — it starts the same way.
          </p>
        </div>
      </div>
    </section>
  );
}
